module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }